import { Alert } from '@mui/material'
import styled from 'styled-components/macro'

const CustomAlert = styled(Alert)`
  box-shadow: none;
  border-width: 2px;
`

export default CustomAlert
